import Loading from './index.vue';

// 定义插件对象
const __Loading__ = {};
// vue的install方法，用于定义vue插件
__Loading__.install = function(Vue, options) {
  const __Loading__Instance = Vue.extend(Loading);
  let current;
  const initInstance = () => {
    // 实例化vue实例
    current = new __Loading__Instance();
    let __Loading__El = current.$mount().$el;
    document.body.appendChild(__Loading__El);
  };
  /**
   * 展示加载层
   * @param {Object | String} options 传入string则为加载为提示文字
   * @param {String} options.mask_bgcolor 遮罩层颜色
   * @param {String} options.loading_text 提示文字，如不设置则不展示提示文字信息
   * @param {String} options.text_color 提示文字颜色
   * @param {String} options.square_color 加载方块颜色
   * @param {String} options.square_shadow_color 加载方块阴影颜色
   * @param {Number} options.square_shadow_opacity 加载方块阴影透明度 0~1
   */
  Vue.prototype.$loading = (options) => {
    if (!current) {
        initInstance();
    }
    current.fnShow(options);
  };
  Vue.prototype.$closeLoading = () => {
    if (current) {
        current.fnClose();
    }
  };
};
export default __Loading__;
